module.exports = __webpack_public_path__ + "img/shopstripy.a1371453.png";